import SlimSelect from 'slim-select';
import { French } from 'flatpickr/dist/l10n/fr';
import intlTelInput from 'intl-tel-input';
import datePicker from '../modules/datepicker';
import Form, { FormError } from '../Form';
import Uploader from '../uploader';
import 'intl-tel-input/styles';
import 'filepond/dist/filepond.css';
import 'slim-select/dist/slimselect.min.css';

class FormConfig {
    constructor() {
        this.formBaseClass = '.form__container';
        this.datepickerClass = '.datepicker';
        this.slimSelectClass = '.slimselect';
        this.init();
    }

    init() {
        Array.from(document.querySelectorAll(this.formBaseClass)).forEach((node) => {
            try {
                Array.from(node.querySelectorAll(this.datepickerClass)).forEach((datepicker) => {
                    datePicker(datepicker, {
                        minDate: 'today',
                        firstDayOfWeek: 1,
                        dateFormat: 'd/m/Y',
                        disable: [
                            // eslint-disable-next-line
                            function (date) {
                                // return true to disable
                                return date.getDay() === 0;
                            },
                        ],
                        locale: French,
                        onClose: [
                            // eslint-disable-next-line
                            function (selectedDates, dateStr, instance) {
                                datepicker.blur();
                            },
                        ],
                    });
                });

                Array.from(node.querySelectorAll(this.slimSelectClass)).forEach((slim) => {
                    const hasSearch = slim.getAttribute('data-hasSearch') === '1';
                    const isMultiple = slim.hasAttribute('multiple');
                    const config = {
                        select: slim,
                        placeholder: slim.getAttribute('placeholder').length
                            ? slim.getAttribute('placeholder')
                            : '-- Choisir une option --',
                        showSearch: hasSearch,
                        searchFocus: true,
                        searchHighlight: true,
                        searchPlaceholder: slim.getAttribute('placeholder'),
                        searchText: 'Aucun résultat',
                    };
                    if (isMultiple) config.allowDeselectOption = true;

                    const select = new SlimSelect(config); // eslint-disable-line
                });

                Array.from(node.querySelectorAll('[type="tel"]')).forEach((phone) => {
                    intlTelInput(phone, {
                        initialCountry: 'fr',
                        countryNameLocale: 'fr',
                        showFlags: true,
                        formatAsYouType: true,
                        loadUtils: () => import('intl-tel-input/utils'),
                        hiddenInputs: () => ({
                            phone: 'phone',
                        }),
                    });
                });

                const form = new Form(node, {
                    async: true,
                    strictMode: false,
                    debug: true,
                });

                if (node.querySelector('input[type="file"]')) {
                    // async = false;
                    const uploader = new Uploader(node, form); // eslint-disable-line
                } else {
                    form.init();
                }

                // if (!async) {
                //     window.submitForm = (token) => { // eslint-disable-line
                //         console.log(token);
                //         form.submit();
                //     };
                // }
            } catch (e) {
                if (!(e instanceof FormError)) {
                    throw e;
                }
                console.warn(e.message); // eslint-disable-line
            }
        });
    }
}

export default FormConfig;
